module.exports = __webpack_public_path__ + "img/1F1F2-1F1FD.fa259c73.svg";